export default "__VITE_ASSET__96f22ad3__"